import { useMemo } from "react";

export interface SharePointSourceSettingsText {
  siteLabelText: string;
  siteHintText: string;
  siteSearchPlaceholderText: string;
  siteSearchMinCharsText: string;
  siteUrlLabelText: string;
  listLabelText: string;
  listHintText: string;
  listPlaceholderText: string;
  meFilterColumnLabelText: string;
  meFilterColumnHintText: string;
  meFilterColumnPlaceholderText: string;
  statusFilterColumnLabelText: string;
  statusFilterColumnHintText: string;
  statusFilterColumnPlaceholderText: string;
  statusesToLoadLabelText: string;
  statusesToLoadHintText: string;
  statusesToLoadPlaceholderText: string;
  doneStatusLabelText: string;
  doneStatusHintText: string;
  doneStatusPlaceholderText: string;
  dueDateColumnLabelText: string;
  dueDateColumnHintText: string;
  dueDateColumnPlaceholderText: string;
  loadingSitesText: string;
  loadingListsText: string;
  loadingColumnsText: string;
  loadErrorText: string;
  siteSearchFailedText: string;
  statusReferenceErrorText: string;
  notSetText: string;
}

export const useSharePointSourceSettingsText = (
  t: (key: string) => string,
): SharePointSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.sharepoint.${key}`);

    return {
      siteLabelText: tKey("siteLabel"),
      siteHintText: tKey("siteHint"),
      siteSearchPlaceholderText: tKey("siteSearchPlaceholder"),
      siteSearchMinCharsText: tKey("siteSearchMinChars"),
      siteUrlLabelText: tKey("siteUrlLabel"),
      listLabelText: tKey("listLabel"),
      listHintText: tKey("listHint"),
      listPlaceholderText: tKey("listPlaceholder"),
      meFilterColumnLabelText: tKey("meFilterColumnLabel"),
      meFilterColumnHintText: tKey("meFilterColumnHint"),
      meFilterColumnPlaceholderText: tKey("meFilterColumnPlaceholder"),
      statusFilterColumnLabelText: tKey("statusFilterColumnLabel"),
      statusFilterColumnHintText: tKey("statusFilterColumnHint"),
      statusFilterColumnPlaceholderText: tKey("statusFilterColumnPlaceholder"),
      statusesToLoadLabelText: tKey("statusesToLoadLabel"),
      statusesToLoadHintText: tKey("statusesToLoadHint"),
      statusesToLoadPlaceholderText: tKey("statusesToLoadPlaceholder"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusHintText: tKey("doneStatusHint"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      dueDateColumnLabelText: tKey("dueDateColumnLabel"),
      dueDateColumnHintText: tKey("dueDateColumnHint"),
      dueDateColumnPlaceholderText: tKey("dueDateColumnPlaceholder"),
      loadingSitesText: tKey("loadingSites"),
      loadingListsText: tKey("loadingLists"),
      loadingColumnsText: tKey("loadingColumns"),
      loadErrorText: tKey("loadError"),
      siteSearchFailedText: tKey("siteSearchFailed"),
      statusReferenceErrorText: tKey("statusReferenceError"),
      notSetText: tKey("notSet"),
    };
  }, [t]);
};
